module.exports = __webpack_public_path__ + "static/media/three-dots.e69db6bb.svg";